<template>
    <div>
            <img v-if="user.phone" :src="'http://chart.apis.google.com/chart?cht=qr&chs=200x200&chl='+user.phone" class="paytmimg" alt="">
            <div v-else class="title" style="text-align:center"> Login Required </div>
     </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    }

}
</script>


<style scoped>
.paytmimg{
        width: 200px;
        position: absolute;
        top:0;left:0;right:0;bottom:0;
        margin:auto;
        }
</style>

